"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-CollectionList',
    loading: 'c-CollectionList--loading',
};
exports.Style = {
    [exports.CSS.container]: {
        padding: theme_1.DefaultTheme.space(1),
    },
    [exports.CSS.loading]: {
        display: 'flex',
        'justify-content': 'center',
    },
};
//# sourceMappingURL=collection.list.style.js.map